import React from 'react'
import './carousel.css'
import Slider from 'react-slick'
import dummyImage from '../../images/art-1.svg'
import img1 from '../../images/img1.png'
import img2 from '../../images/img2.png'
import img3 from '../../images/img3.png'
import img4 from '../../images/img4.png'
import img5 from '../../images/img5.png'
import img6 from '../../images/img6.png'
import img7 from '../../images/img7.png'
import img8 from '../../images/img8.png'
import img9 from '../../images/img9.png'
import img10 from '../../images/img10.png'
import img11 from '../../images/img11.png'
import img12 from '../../images/img12.png'
import img13 from '../../images/img13.png'
import sliderBack from '../../images/slider-back.svg'
import next from '../../images/next.svg'
import prev from '../../images/previous.svg'

import { Avatar } from '@mui/material'

import CC from "../../images/shangu_updated/CC.jpg";
import CC1 from "../../images/shangu_updated/CC(1).jpg";
import CC2 from "../../images/shangu_updated/CC(2).jpg";
import CC3 from "../../images/shangu_updated/CC(3).jpg";
import CC4 from "../../images/shangu_updated/CC(4).jpg";
import CC5 from "../../images/shangu_updated/CC(5).jpg";
import CC6 from "../../images/shangu_updated/CC(6).jpg";
import CC7 from "../../images/shangu_updated/CC(7).jpg";




function NextArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            src={next}
            className={className}
            style={{ ...style, display: 'block', fontSize: '40px' }}
            onClick={onClick}
        />
    )
}

function PrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            src={prev}
            className={className}
            style={{ ...style, display: 'block', fontSize: '40px' }}
            onClick={onClick}
        />
    )
}

const CarouselSlider = () => {
    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1392,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    }
    return (
        <div className='carousel-slider'>
            <div className='carousel-slider-heading'>
                <div>
                    <h2>
                        Featured <span>Legends</span>
                    </h2>
                </div>
            </div>

            <Slider {...settings}>
                <div className='slider-super'>
                    <div className='slider-box'>
                        <div>
                            {/* <img src={sliderBack} alt="" /> */}
                            <Avatar
                                className='slider-box-avatar'
                                alt='Remy Sharp'
                                src={CC}
                                sx={{ width: 250, height: 250 }}
                            />
                            {/* <div className="slider-box-title">
                          <h2>Shangu Name</h2>
                          <h3>DD/MM/YYYY</h3>
                        </div> */}
                        </div>
                    </div>
                </div>

                <div className='slider-super'>
                    <div className='slider-box'>
                        <div>
                            {/* <img src={sliderBack} alt="" /> */}
                            <Avatar
                                className='slider-box-avatar'
                                alt='Remy Sharp'
                                src={CC1}
                                sx={{ width: 250, height: 250 }}
                            />
                            {/* <div className="slider-box-title">
                          <h2>Shangu Name</h2>
                          <h3>DD/MM/YYYY</h3>
                        </div> */}
                        </div>
                    </div>
                </div>

                <div className='slider-super'>
                    <div className='slider-box'>
                        <div>
                            {/* <img src={sliderBack} alt="" /> */}
                            <Avatar
                                className='slider-box-avatar'
                                alt='Remy Sharp'
                                src={CC2}
                                sx={{ width: 250, height: 250 }}
                            />
                            {/* <div className="slider-box-title">
                          <h2>Shangu Name</h2>
                          <h3>DD/MM/YYYY</h3>
                        </div> */}
                        </div>
                    </div>
                </div>

                <div className='slider-super'>
                    <div className='slider-box'>
                        <div>
                            {/* <img src={sliderBack} alt="" /> */}
                            <Avatar
                                className='slider-box-avatar'
                                alt='Remy Sharp'
                                src={CC3}
                                sx={{ width: 250, height: 250 }}
                            />
                            {/* <div className="slider-box-title">
                          <h2>Shangu Name</h2>
                          <h3>DD/MM/YYYY</h3>
                        </div> */}
                        </div>
                    </div>
                </div>

                <div className='slider-super'>
                    <div className='slider-box'>
                        <div>
                            {/* <img src={sliderBack} alt="" /> */}
                            <Avatar
                                className='slider-box-avatar'
                                alt='Remy Sharp'
                                src={CC4}
                                sx={{ width: 250, height: 250 }}
                            />
                            {/* <div className="slider-box-title">
                          <h2>Shangu Name</h2>
                          <h3>DD/MM/YYYY</h3>
                        </div> */}
                        </div>
                    </div>
                </div>

                <div className='slider-super'>
                    <div className='slider-box'>
                        <div>
                            {/* <img src={sliderBack} alt="" /> */}
                            <Avatar
                                className='slider-box-avatar'
                                alt='Remy Sharp'
                                src={CC5}
                                sx={{ width: 250, height: 250 }}
                            />
                            {/* <div className="slider-box-title">
                          <h2>Shangu Name</h2>
                          <h3>DD/MM/YYYY</h3>
                        </div> */}
                        </div>
                    </div>
                </div>

                <div className='slider-super'>
                    <div className='slider-box'>
                        <div>
                            {/* <img src={sliderBack} alt="" /> */}
                            <Avatar
                                className='slider-box-avatar'
                                alt='Remy Sharp'
                                src={CC6}
                                sx={{ width: 250, height: 250 }}
                            />
                            {/* <div className="slider-box-title">
                          <h2>Shangu Name</h2>
                          <h3>DD/MM/YYYY</h3>
                        </div> */}
                        </div>
                    </div>
                </div>

                <div className='slider-super'>
                    <div className='slider-box'>
                        <div>
                            {/* <img src={sliderBack} alt="" /> */}
                            <Avatar
                                className='slider-box-avatar'
                                alt='Remy Sharp'
                                src={CC7}
                                sx={{ width: 250, height: 250 }}
                            />
                            {/* <div className="slider-box-title">
                          <h2>Shangu Name</h2>
                          <h3>DD/MM/YYYY</h3>
                        </div> */}
                        </div>
                    </div>
                </div>

                
            </Slider>
        </div>
    )
}

export default CarouselSlider
